module.exports = __webpack_public_path__ + "ae8272e20fc4bf95ba876c4e69e19488.svg";